import { render, staticRenderFns } from "./AjaxMultiselect.vue?vue&type=template&id=97642106"
import script from "./AjaxMultiselect.vue?vue&type=script&lang=js"
export * from "./AjaxMultiselect.vue?vue&type=script&lang=js"
import style0 from "./AjaxMultiselect.vue?vue&type=style&index=0&id=97642106&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports